/*
 * The family's children, fetched once.
 *
 * Every screen in the family's panel is about a child, and each of them used
 * to ask who the children were and carry its own dropdown to choose between
 * them. Three sources of truth for one question, three requests for one list,
 * and a selection that was lost the moment anybody navigated - so a parent
 * reading their second child's history was editing their first child's alerts
 * one click later.
 *
 * The child is chosen once and remembered here instead. A household with one
 * child - which is most of them - never sees a chooser at all.
 */
const CHOSEN = "familyChild"

let children = null
let inflight = null

export default {
  /** The children, from memory if we have them. */
  list(force) {
    if (force) {
      children = null
    }

    if (children) {
      return Promise.resolve(children)
    }

    //a page whose tabs all mount at once must not make the same request thrice
    if (inflight) {
      return inflight
    }

    inflight = axios
      .get("/parent-portal/children")
      .then(response => {
        children = response.data.children || []
        inflight = null

        return children
      })
      .catch(error => {
        inflight = null
        throw error
      })

    return inflight
  },

  /**
   * Which child a screen should be about.
   *
   * In order: the one asked for, the one last looked at, the first one. The
   * fallbacks matter more than they look - a bookmarked link to a child who
   * has since left the school should open the panel, not an error.
   */
  choose(list, asked) {
    const known = (list || []).map(child => child.id)
    const wanted = Number(asked)

    if (known.indexOf(wanted) !== -1) {
      return wanted
    }

    const last = Number(localStorage.getItem(CHOSEN))
    if (known.indexOf(last) !== -1) {
      return last
    }

    return known.length ? known[0] : null
  },

  remember(id) {
    if (id) {
      localStorage.setItem(CHOSEN, String(id))
    }
  },

  /** On the way out, so the next person to sign in is not shown this family. */
  forget() {
    children = null
    inflight = null
    localStorage.removeItem(CHOSEN)
  },
}
